import { composeFieldPath } from '@northfork/basics'

export interface AccountDetails {
  accountId: number
  accountName: string
  accountManager: string
  accountManagerEmail: string
  isAggregate: boolean
  isAutoReconciled: boolean
  baseCurrency: string
  clientId: number
  clientName: string
  stableDate: string
  custodyBankName: string
  custodyBankNumber: string
  isMmfInterestAccrued: boolean
  isMultiCurrency: boolean
  isReconciledDaily: boolean
  reconciler: string
  configuredBases: string[]
  defaultBasis: number
  demo: boolean
  prefixBases?: string[]
  mirrorSourceAccount?: string
}
export interface ClientCustodyContact {
  id: number
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
}

export interface TransportDetails {
  dataFeedId: number
  name: string
  contactSize: number
  contacts: ClientCustodyContact[]
}

export interface AccountNotes {
  accountID: number
  active: number
  date: string
  note: string
  noteID: number
  userID: number
}

export interface AccountNotesModel {
  notes: AccountNotes[]
}

export interface AccountDetailsModel {
  property: string
  value: string
}

export const accountDetailsField = composeFieldPath([] as AccountDetailsModel[])
